import {SOURCE_ACCOUNT_FIELD_ID} from '@/components/document/hooks/use-prefilled-source-investor-account';
import {INVE_FIELDS} from '@/constants/inve';
import {DocumentData} from '@/engine';
import {InvestorAccount} from '@/types/client-info';
import {resolveSelectorIndex} from './resolve-selector-index';

export const findSelectedSourceAccount = (
  oldData: DocumentData['data'],
  reorderedAccounts: InvestorAccount[],
): string | null => {
  const selectedIndex = resolveSelectorIndex(oldData[SOURCE_ACCOUNT_FIELD_ID]);
  if (!selectedIndex) return null;

  const oldAccountNo = oldData[`${INVE_FIELDS.INVE43_existingAccountNo}#${selectedIndex}`];
  if (typeof oldAccountNo !== 'string') return null;

  const newIndex = reorderedAccounts.findIndex(account => account.accountNo.toString() === oldAccountNo);
  return newIndex >= 0 ? String(newIndex) : null;
};
